export default __webpack_public_path__ + "static/media/collab.2e84aa12.jpg";